import { ACTION_IDS } from 'commons-ui/src/settingsV2Constant';

export const makeActionHandler = (action: any, params?: any) => {
	const { history } = params || {};

	switch (action.id) {
		case ACTION_IDS.ADD:
			return () => {
				const basePath: string = history.location.pathname.replace(/\/list$/, '');
				history.push(`${basePath}/create`);
			};
		default:
			return () => {};
	}
};
